import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

/** A compact on/off switch shown as a chip; filled when on. */
@Component({
  selector: 'app-toggle-chip',
  templateUrl: './toggle-chip.component.html',
  styleUrl: './toggle-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleChipComponent {
  readonly label = input.required<string>();
  readonly checked = model(false);
  readonly disabled = input(false);

  toggle(): void {
    if (this.disabled()) return;
    this.checked.set(!this.checked());
  }
}
